import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid } from '@material-ui/core';
import { NAME_SPACE } from 'i18n';
import { Form, Input } from '@engloba-tech/englobity';

export function ViewErrors({ requestErrors }) {
  const { t } = useTranslation(NAME_SPACE.READER_REQUESTS);

  return (
    <Form autoComplete="off" onSubmit={() => null}>
      <Grid container spacing={3}>
        <Grid xs={12} item>
          <Input
            multiline
            fullWidth
            name={t('properties.errors')}
            label={t('properties.errors')}
            variant="outlined"
            value={requestErrors || ''}
            inputProps={{ 'aria-label': t('properties.errors') }}
            rows={10}
          />
        </Grid>
      </Grid>
    </Form>
  );
}

ViewErrors.propTypes = {
  requestErrors: PropTypes.string.isRequired
};
